import { Stack, Typography } from '@mui/material';
import HomepPageList from '../../../../../Home/components/FourSolutions/components/HompageList';

const whatYouWillDo = [
  'Support senior team members with outbound outreach and lead follow-up',
  'Assist in conducting product demos and subscription sales conversations',
  'Guide clients through the onboarding process and ensure successful implementation',
  'Monitor customer activity and surface opportunities for growth and retention',
  'Respond to client questions and coordinate internally to resolve any issues',
  'Work closely with the sales and customer success team to improve processes',
];

const youshouldHave = [
  '1–2 years in a sales, onboarding, or customer-facing role (internships welcome)',
  'Strong communication and problem-solving skills',
  'A proactive attitude and willingness to learn quickly',
  'Interest in SaaS, media tools, or project management tech',
  'Based in or near Dublin – this is an on-site position at our CoCreate office',
];

const JuniorCustomerGrowthSpecialist = () => (
  <Stack spacing={3}>
    <Typography variant="publicBody4">
      Location: Dublin (Sandyford, 6 Fern Road) | Type: Full-time | Industry: SaaS / Project
      Management / Media Tech
    </Typography>
    <Typography variant="publicBody4Regular">
      Kickstart your growth career with us. We’re looking for a Junior Customer Growth Specialist
      who will help support the adoption of the Spona platform by new clients across Europe. You’ll
      assist in prospecting, demos, onboarding, and maintaining high service standards post-sale.
    </Typography>

    <Stack>
      <Typography
        sx={{
          typography: { xs: 'publicBody5', sm: 'publicBody4' },
        }}
      >
        What you will do:
      </Typography>
      <HomepPageList items={whatYouWillDo} sx={{ pl: { xs: '0.75rem', sm: '1.5rem' } }} />
    </Stack>

    <Stack>
      <Typography
        sx={{
          typography: { xs: 'publicBody5', sm: 'publicBody4' },
        }}
      >
        You should have:
      </Typography>
      <HomepPageList items={youshouldHave} sx={{ pl: { xs: '0.75rem', sm: '1.5rem' } }} />
    </Stack>

    <Typography variant="publicBody4">Please send your CV to: matija@spona.io</Typography>
  </Stack>
);

export default JuniorCustomerGrowthSpecialist;
